import React, {memo} from 'react'

const ReturnPolicy = memo(
  ({
    returnPolicy
  }) => {
    return (
      <div data-test-id={'return-policy'} dangerouslySetInnerHTML={{__html: returnPolicy?.result?.data?.data?.returnPolicy}}/>
    )
  }
)

export default ReturnPolicy
